export default __webpack_public_path__ + "static/media/icon_collect_status_remain_audit.272b9474.png";